import React from "react";
import { useLocation, Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Lock, Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminLogin() {
  const { user, loading } = useAuth();
  const location = useLocation();
  const errorCode = location.state?.error;

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#09090b]">
        <Loader2 className="animate-spin text-[#d4af37]" />
      </div>
    );
  }
  if (user?.is_admin) {
    return <Navigate to="/admin" replace />;
  }

  const login = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#09090b] text-white flex items-center justify-center px-6">
      <div className="max-w-md w-full">
        <div className="text-center mb-12">
          <div className="w-14 h-14 bg-[#d4af37] mx-auto flex items-center justify-center font-display text-2xl font-bold text-black mb-6">B</div>
          <h1 className="font-display text-4xl tracking-tight mb-3" data-testid="admin-login-title">Console Blackline</h1>
          <p className="text-zinc-500 text-sm">Accès réservé aux administrateurs.</p>
        </div>

        {errorCode === "not_admin" && (
          <div className="bg-red-950/40 border border-red-900/50 px-4 py-3 mb-6 text-sm text-red-200" data-testid="error-not-admin">
            Ce compte n'a pas les droits administrateur.
          </div>
        )}
        {errorCode === "auth_failed" && (
          <div className="bg-red-950/40 border border-red-900/50 px-4 py-3 mb-6 text-sm text-red-200" data-testid="error-auth-failed">
            Connexion échouée. Réessayez.
          </div>
        )}

        <button
          onClick={login}
          data-testid="google-login-btn"
          className="w-full btn-gold py-4 inline-flex items-center justify-center gap-3 text-sm">
          <Lock size={16} /> Se connecter avec Google
        </button>

        <p className="text-zinc-600 text-xs text-center mt-8">
          Authentification sécurisée par Emergent · Sessions 7 jours
        </p>
      </div>
    </div>
  );
}
